export default [
    { Id: 8, Value: '8', Text: 'General Surveys' },
    { Id: 4, Value: '4', Text: 'School Administrator Observations' },
    { Id: 1, Value: '1', Text: 'Teacher Observations' }
]